<template lang="html">
  <div class="item-details-wrapper">
    <div class="information-wrapper">
      <div v-for="(key, index) in mainData" :key="index" class="wrapp-info">
        <!-- <div
          v-if="
            (key === 'quitSection' ||
              key === 'responsibilitySection' ||
              key === 'otherRights' ||
              key === 'transportSection' ||
              key === 'international' ||
              key === 'localSection' ||
              key === 'socialsSection' ||
              key === 'quantityDiscountSection' ||
              key === 'mainSection') &&
              isNotEmpty(key)
          "
          class="header"
        >
          {{ $t("main." + key) }}
        </div> -->

        <div
          v-if="
            key === 'pro_base_price' ||
              (key === 'current_price' && productInfo[key])
          "
          class="info"
        >
          <span class="info-key">{{ $t("details.details." + key) }}:</span>
          <div v-if="productInfo[key]" class="info-value">
            {{
              productInfo[key]
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            {{ productInfo.cur_id }}
          </div>
        </div>

        <div v-else-if="key === 'mun_unit'" class="info">
          <span class="info-key">{{ $t("details.details." + key) }}:</span>
          <div class="info-value">
            {{ showUnit }}
          </div>
        </div>

        <div
          v-else-if="
            key === 'quantity' || (key === 'available' && productInfo[key])
          "
          class="info"
        >
          <span class="info-key">{{ $t("details.details." + key) }}:</span>
          <div v-if="productInfo[key]" class="info-value">
            {{
              parseInt(productInfo[key])
                .toLocaleString("en")
                .split(",")
                .join(".")
            }}
            {{ showUnit }}
          </div>
        </div>
        <div v-else-if="key === 'regions' && productInfo[key]" class="info">
          <span class="info-key">{{ $t("details.details." + key) }}:</span>
          <div class="info-value">
            <span v-for="(region, index) in productInfo[key]" :key="index"
              >{{
                region.reg_name === "Ceo svet"
                  ? $t("worldWide")
                  : region.reg_name
              }}{{ productInfo[key][index + 1] ? ", " : "" }}
            </span>
          </div>
        </div>
        <div v-else-if="key === 'pro_declaration_text' && productInfo[key]">
          <!-- <div v-if="productInfo['pro_declaration']" class="info-value">
          </div> -->
          <div v-if="!productInfo['pro_declaration']" class="info">
            <span class="info-key">{{ $t("details.details." + key) }}:</span>
            <span class="info-value">{{ productInfo[key] }}</span>
          </div>
        </div>
        <div
          v-else-if="key === 'pro_declaration' && productInfo[key]"
          class="info"
        >
          <span class="info-key">{{ $t("details.details." + key) }}:</span>
          <div class="info-value">
            <span v-if="productInfo.pro_declaration_text"
              >{{ productInfo.pro_declaration_text }},
            </span>
            <div v-for="file in productInfo[key]" :key="file.prq_name">
              <a :href="getBaseUrl + file.link">{{ file.prq_name }}</a>
            </div>
          </div>
        </div>
        <template
          v-else-if="
            key === 'pro_rules' ||
              key === 'pro_form' ||
              key === 'pro_reject_form' ||
              key === 'pro_reject_rules'
          "
        >
          <div v-if="productInfo['pro_individuals_trading'] === 1" class="info">
            <span class="info-key">{{ $t("details.details." + key) }}:</span>
            <div v-if="key === 'pro_rules'" class="info-value">
              <span v-if="productInfo[key]">{{ productInfo[key] }}</span>
              <router-link
                v-else
                :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
                >{{ $t("nav.rules") }}</router-link
              >
            </div>
            <div v-else-if="key === 'pro_reject_rules'" class="info-value">
              <span v-if="productInfo[key]">{{ productInfo[key] }}</span>
              <router-link
                v-else
                :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
                >{{ $t("nav.rules") }}</router-link
              >
            </div>
            <div v-else-if="key === 'pro_form'" class="info-value">
              <router-link
                :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
                >{{ $t("nav.rules") }}</router-link
              >
            </div>
            <div v-else-if="key === 'pro_reject_form'" class="info-value">
              <router-link
                :to="{ name: 'Rules', params: { lang: $i18n.locale } }"
                >{{ $t("nav.rules") }}</router-link
              >
            </div>
          </div>
        </template>
        <template
          v-else-if="
            key === 'pro_return_shipping_requirements' ||
              key === 'pro_no_reject_condition' ||
              key === 'pro_postal_info' ||
              key === 'pro_court_avoidance' ||
              key === 'pro_return_shipping_cost'
          "
        >
          <div
            v-if="
              key === 'pro_return_shipping_requirements' &&
                productInfo['pro_individuals_trading'] === 1 &&
                productInfo[key]
            "
            class="info"
          >
            <span class="info-key">{{ $t("details.details." + key) }}:</span>
            <div class="info-value">
              <span v-if="productInfo[key]">{{ productInfo[key] }}</span>
            </div>
          </div>
          <div
            v-else-if="
              key === 'pro_no_reject_condition' &&
                productInfo['pro_individuals_trading'] === 1 &&
                productInfo[key]
            "
            class="info"
          >
            <span class="info-key">{{ $t("details.details." + key) }}</span>
            <div class="info-value">
              <span v-if="productInfo[key]">{{ productInfo[key] }}</span>
            </div>
          </div>
          <div
            v-else-if="
              key === 'pro_postal_info' &&
                productInfo['pro_individuals_trading'] === 1 &&
                productInfo[key]
            "
            class="info"
          >
            <span class="info-key">{{ $t("details.details." + key) }}:</span>
            <div class="info-value">
              <span v-if="productInfo[key]">{{ productInfo[key] }}</span>
            </div>
          </div>
          <div
            v-else-if="
              key === 'pro_return_shipping_cost' &&
                productInfo['pro_individuals_trading'] === 1 &&
                productInfo[key]
            "
            class="info"
          >
            <span class="info-key">{{ $t("details.details." + key) }}:</span>
            <div class="info-value">
              <span v-if="productInfo[key]">{{ productInfo[key] }}</span>
            </div>
          </div>
          <div
            v-else-if="
              key === 'pro_court_avoidance' &&
                productInfo['pro_individuals_trading'] === 1 &&
                productInfo[key]
            "
            class="info"
          >
            <span class="info-key">{{ $t("details.details." + key) }}:</span>
            <div class="info-value">
              <span v-if="productInfo[key]">{{ productInfo[key] }}</span>
            </div>
          </div>
        </template>
        <div
          v-else-if="productInfo[key] || productInfo[key] === 0"
          class="info"
        >
          <span class="info-key">{{ $t("details.details." + key) }}:</span>
          <div v-if="key === 'socials'" class="info-value">
            <div v-for="soc in productInfo[key]" :key="soc.sct_name">
              <span>{{ soc.sct_name }}: </span>
              <a
                v-if="isValidHttpUrl(soc.link)"
                target="_blank"
                :href="soc.link"
                class="social-link"
                >{{ soc.link }}</a
              >
              <span v-else class="social-link">{{ soc.link }}</span>
            </div>
          </div>
          <div
            v-else-if="key === 'prices'"
            v-html="getPricesComputed"
            class="info-value"
          ></div>
          <!-- v-html="getPrices(productInfo[key])" -->
          <div v-else-if="key === 'pro_quality'" class="info-value">
            <div v-for="file in productInfo[key]" :key="file.prq_name">
              <a :href="getBaseUrl + file.link">{{ file.prq_name }}</a>
            </div>
          </div>
          <div
            v-else-if="
              key === 'pro_abandon' ||
                key === 'pro_abandon_no_offers' ||
                key === 'pro_seller_shipping' ||
                key === 'pro_free_shipping' ||
                key === 'pro_shipping_included' ||
                key === 'pro_reject'
            "
            class="info-value"
          >
            <!-- {{
              parseInt(productInfo[key]) === 1 ? $t("main.yes") : $t("main.no")
            }} -->
            <img
              v-if="parseInt(productInfo[key]) === 1"
              src="@/assets/newImges/correct.svg"
              alt=""
              srcset=""
            />
            <img
              v-else
              src="@/assets/newImges/VectorRed.svg"
              alt=""
              srcset=""
            />
          </div>

          <span v-else class="info-value">{{ productInfo[key] }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { baseURL } from "@/api";
export default {
  name: "itemDetails",
  props: {
    productInfo: {
      type: Object
    }
  },
  data() {
    return {
      // textGetPrices: "",
      mainData: [
        "mainSection",
        "pro_post_date",
        "pro_expiry",
        "mun_unit",
        "pro_base_price",
        "cur_id",
        "pro_info",
        "pro_description",
        "regions",
        "pro_made_in",
        "pro_declaration",
        "pro_declaration_text",
        "pro_quality",
        "pro_selling_price",
        "quantityDiscountSection",
        "prices",
        "quantity",
        "available",
        "current_price",
        "socialsSection",
        "socials",
        "localSection",
        "pro_shipping_time",
        "pro_shipping_info",
        "pro_seller_shipping",
        "pro_free_shipping",
        "pro_shipping_included",
        "pro_shipping_additional",
        "international",
        "pro_international_shipping",
        "transportSection",
        "trc_code",
        "trc_code_naval",
        "quitSection",
        "pro_reject",
        "pro_abandon",
        "pro_abandon_no_offers",
        "pro_limitations",
        "responsibilitySection",
        "pro_jurisdiction",
        "rst_name",
        "otherRights",
        "pro_payment_info",
        "pro_deposit_info",
        "pro_contract_requirements",
        "pro_claims_info",
        "pro_claims_responsibility",
        "pro_warranty_info",
        "pro_warranty_address",
        "pro_return_shipping_requirements",
        "pro_no_reject_condition",
        "pro_postal_info",
        "pro_return_shipping_cost",
        "pro_court_avoidance",
        "pro_rules",
        "pro_reject_rules",
        "pro_form",
        "pro_reject_form"
      ],
      carouselIndex: 0
    };
  },
  mounted() {
    // this.getPrices(this.productInfo.prices);
  },
  methods: {
    isValidHttpUrl(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return false;
      }
      return url.protocol === "http:" || url.protocol === "https:";
    }
    // getPrices(prices) {
    //   let str = "";
    //   for (var i = 0; i < prices.length; i++) {
    //     const price = prices[i];
    //     str +=
    //       price.min
    //         .toLocaleString("en")
    //         .split(",")
    //         .join(".") +
    //       " - " +
    //       price.max
    //         .toLocaleString("en")
    //         .split(",")
    //         .join(".") +
    //       " " +
    //       // this.productInfo.mun_unit +
    //       (this.productInfo.mun_unit === "komad" ||
    //       this.productInfo.mun_unit === "komada"
    //         ? this.$t("item.items")
    //         : this.productInfo.mun_unit) +
    //       " - " +
    //       price.price
    //         .toLocaleString("en")
    //         .split(",")
    //         .join(".") +
    //       " " +
    //       this.productInfo.cur_id +
    //       "<br>";
    //   }
    //   this.textGetPrices = str;
    // },
    // getImageSrc(index) {
    //   return baseURL + this.productInfo.pro_image[index];
    // },
    // showSlide(index) {
    //   this.carouselIndex = index;
    // },
    // showSlide2(e) {
    //   this.carouselIndex = e;
    // }
  },
  computed: {
    showUnit() {
      if (
        this.productInfo.mun_unit === "komad" ||
        this.productInfo.mun_unit === "komada"
      ) {
        return this.$t("item.items");
      } else if (
        this.productInfo.mun_unit === "paket" ||
        this.productInfo.mun_unit === "paketa"
      ) {
        return this.$t("item.package");
      }
      return this.productInfo.mun_unit;
    },
    getPricesComputed() {
      let str = "";
      for (var i = 0; i < this.productInfo.prices.length; i++) {
        const price = this.productInfo.prices[i];
        if (!price) return;
        str +=
          price.min
            .toLocaleString("en")
            .split(",")
            .join(".") +
          " - " +
          price.max
            .toLocaleString("en")
            .split(",")
            .join(".") +
          " " +
          // this.productInfo.mun_unit +
          this.showUnit +
          " - " +
          price.price
            .toLocaleString("en")
            .split(",")
            .join(".") +
          " " +
          this.productInfo.cur_id +
          "<br>";
      }
      return str;
    },
    // getMainImage() {
    //   return this.productInfo.pro_image
    //     ? this.getImageSrc(this.carouselIndex)
    //     : null;
    // },
    // getMainImage2() {
    //   let res =
    //     this.productInfo.pro_image && this.productInfo.pro_image.length !== 0
    //       ? this.getImageSrc(this.carouselIndex)
    //       : null;
    //   console.log(res);
    //   return res;
    // },
    getBaseUrl() {
      return baseURL;
    },
    isNotEmpty() {
      return key => {
        if (key === "socialsSection") {
          if (this.productInfo.socials && this.productInfo.socials.length > 0) {
            return true;
          } else {
            return false;
          }
        } else if (key === "localSection") {
          if (
            this.productInfo.pro_shipping_time ||
            this.productInfo.pro_shipping_info ||
            this.productInfo.pro_seller_shipping ||
            this.productInfo.pro_free_shipping ||
            this.productInfo.pro_shipping_info === 0 ||
            this.productInfo.pro_seller_shipping === 0 ||
            this.productInfo.pro_free_shipping === 0 ||
            this.productInfo.pro_shipping_included ||
            this.productInfo.pro_shipping_additional
          ) {
            return true;
          } else {
            return false;
          }
        } else if (key === "international") {
          if (this.productInfo.pro_international_shipping) {
            return true;
          } else {
            return false;
          }
        } else if (key === "transportSection") {
          if (this.productInfo.trc_code || this.productInfo.trc_code_naval) {
            return true;
          } else {
            return false;
          }
        } else if (key === "otherRights") {
          if (
            (this.productInfo.pro_return_shipping_requirements &&
              this.productInfo.pro_individuals_trading === 1) ||
            (this.productInfo.pro_no_reject_condition &&
              this.productInfo.pro_individuals_trading === 1) ||
            (this.productInfo.pro_postal_info &&
              this.productInfo.pro_individuals_trading === 1) ||
            (this.productInfo.pro_return_shipping_cost &&
              this.productInfo.pro_individuals_trading === 1) ||
            (this.productInfo.pro_court_avoidance &&
              this.productInfo.pro_individuals_trading === 1) ||
            this.productInfo.pro_payment_info ||
            this.productInfo.pro_deposit_info ||
            this.productInfo.pro_contract_requirements ||
            this.productInfo.pro_claims_info ||
            this.productInfo.pro_claims_responsibility ||
            this.productInfo.pro_warranty_info ||
            this.productInfo.pro_warranty_address
          ) {
            return true;
          } else {
            return false;
          }
        } else if (key === "responsibilitySection") {
          if (this.productInfo.pro_jurisdiction || this.productInfo.rst_name) {
            return true;
          } else {
            return false;
          }
        } else if (key === "quitSection") {
          if (
            this.productInfo.pro_reject ||
            this.productInfo.pro_abandon ||
            this.productInfo.pro_abandon_no_offers ||
            this.productInfo.pro_reject === 0 ||
            this.productInfo.pro_abandon === 0 ||
            this.productInfo.pro_abandon_no_offers === 0 ||
            this.productInfo.pro_limitations
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      };
    }
  }
  // watch: {
  //   "$route.params.lang": {
  //     handler: function() {
  //       this.getPrices(this.productInfo.prices);
  //     }
  //   }
  // }
};
</script>

<style lang="scss" scoped>
.item-details-wrapper {
  box-sizing: border-box;
  min-width: 100% !important;
  display: flex;
  flex-direction: row;
  position: relative;
  flex-wrap: wrap;
  margin-top: 20px;

  .information-wrapper {
    box-sizing: border-box;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
    color: $text-color;

    .wrapp-info {
      width: 100%;
    }

    .info {
      box-sizing: border-box;
      width: 100%;
      // margin-bottom: 15px;
      display: flex;
      flex-direction: row;
      // align-items: center;
      // flex-wrap: wrap;
      min-height: 43px;
      padding: 15px;
      border-bottom: 1px solid $gray-blue-700;

      font-weight: 400;
      font-style: Regular;
      font-size: 18px;
      line-height: 130%;
      letter-spacing: 0%;

      .info-key {
        width: 248px;
        min-width: 248px;

        color: $blue-400;
        margin-right: 15px;
        white-space: break-spaces;

        // width: 300px;
      }
      .info-value {
        margin-left: 15px;

        color: $blue-1000;
        // word-break: break-all;
        img {
          width: 23px;
        }
      }
    }
    .section-end {
      margin-top: 10px;
      margin-bottom: 20px;
      height: 1px;
      width: 100%;
      background-color: #eaeaea;
    }
  }
}
.noBig {
  box-sizing: border-box;
  border: solid 2px rgba(233, 120, 110, 0);
}
.big {
  box-sizing: border-box;
  border: solid 2px rgba(233, 120, 110, 0.534);
}
@media only screen and (max-width: 1000px) {
  .item-details-wrapper {
    flex-direction: column;

    .images {
      width: 100%;
      max-width: 500px;
      margin: 0 auto;
      margin-bottom: 60px;
      padding-right: 0px;
    }
    .information-wrapper {
      width: 100%;
    }
  }
}

@media only screen and (max-width: 768px) {
  .item-details-wrapper {
    box-sizing: border-box;
    min-width: 100% !important;
    display: flex;
    flex-direction: row;
    position: relative;
    flex-wrap: wrap;
    margin-top: 20px;

    .information-wrapper {
      .wrapp-info {
        width: 100%;
      }

      .info {
        box-sizing: border-box;
        width: 100%;
        // margin-bottom: 15px;
        display: flex;
        flex-direction: column;

        min-height: 43px;
        padding: 5px;

        font-size: 16px;
        line-height: 130%;

        .info-value {
          margin-bottom: 15px;

          img {
            width: 18px;
          }
        }
      }
    }
  }
  .social-link {
    word-break: break-all !important;
  }
  .info-key {
    white-space: break-spaces !important;
    width: 100% !important;
    min-width: 100% !important;
    font-size: 14px !important;
  }
}
</style>
<style lang="scss">
// .VueCarousel-dot {
//   outline: none !important;
// }
// .VueCarousel-inner {
//   align-items: center;
//   justify-content: space-between;
// }
// .VueCarousel-pagination {
//   position: absolute;
//   bottom: -30px;
//   height: 30px;

//   .VueCarousel-dot-container {
//     height: 30px;
//     margin-top: 0px !important;

//     button {
//       margin-top: 0px !important;
//     }
//   }
// }
</style>
